import DensityOptionState from './schema/DensityOptionState';
import { createStore } from 'satcheljs';

export default createStore<DensityOptionState>('densityOptionState', {
    densityModeSelected: null,
});
